import React from 'react';
import { SuiTooltipPopover } from '@splashthat/sui';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import { getIsUserUsingRoleBasedPermissions } from 'common/store/userProperties/selectors';

/**
 * This is a higher order component that we wrap other components that use RBAC permissions
 * If the permission we pass in returns false, we display the SuiTooltipPopover
 */
const DISABLED_MESSAGE = `Your role does not have access to this feature.
    If you believe this is a mistake, please reach out to your team administrator.`;

const FullWidthContainer = styled.div`
    width: 100%;
`;

/**
 * SuiToolTipPopover always displays a colored modal
 * for the disablePopover prop: true = gray background, false = black background
 */
const defaultWrapper = (child, customMessage, disablePopover) => (
    <SuiTooltipPopover content={isEmpty(customMessage) ? DISABLED_MESSAGE : customMessage} disabled={disablePopover}>
        <FullWidthContainer>{child}</FullWidthContainer>
    </SuiTooltipPopover>
);

const PermissionCheckWrapper = ({
    permission,
    children,
    wrapper = defaultWrapper,
    customMessage,
    disablePopover = true,
    ...restProps
}) => {
    const isUserUsingRoleBasedPermissions = useSelector(getIsUserUsingRoleBasedPermissions);
    if (!isUserUsingRoleBasedPermissions) {
        return children(restProps);
    }
    return !permission ? wrapper(children(restProps), customMessage, disablePopover) : children(restProps);
};

export default PermissionCheckWrapper;

export { DISABLED_MESSAGE };
